import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapturumSharedModule } from '@capturum/ui/api';
import { CapturumInputModule } from '@capturum/ui/input';
import { InputPrefixDirective } from '@core/directives/input-prefix.directive';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { DndDropEvent, DndModule } from 'ngx-drag-drop';

@Component({
  selector: 'app-formly-input-type',
  imports: [
    FormlyModule,
    CapturumInputModule,
    FormsModule,
    ReactiveFormsModule,
    CapturumSharedModule,
    AsyncPipe,
    DndModule,
    InputPrefixDirective,
  ],
  templateUrl: './formly-input-type.component.html',
  styleUrl: './formly-input-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyInputTypeComponent extends FieldType {
  defaultFilter = new RegExp('');

  onDrop(event: DndDropEvent): void {
    if (event.data) {
      const formValue = this.formControl?.value || '';
      const data = this.props.noPlaceholder ? event.data : `{{${event.data}}}`;

      this.formControl.patchValue(`${formValue}${data}`, {
        emitEvent: false,
      });
    }
  }
}
